import { ForexApprovalState } from "@/feature/Forex/store/approval/interface";
import { ForexOperationType } from "@/feature/Forex/api/forex.interface";
import { PaymentOrderType } from "@/feature/Forex/api/approval/forex-approval.interface";

export default <ForexApprovalState> {
	list: [],
	loadingCount: 0,
	isEndPage: false,
	pageSize: 25,
	pageNumber: 1,
	operationType: null,
	paymentOrderCount: {
		[PaymentOrderType.UZS]: 0,
		[PaymentOrderType.SWIFT]: 0,
	},
	toApprovalCount: {
		[ForexOperationType.ALL]: 0,
		[ForexOperationType.BUY]: 0,
		[ForexOperationType.SELL]: 0,
	}
}